import { reportUsageV2 } from '../../../api/usageV2';
import { getProtobufSearchScope } from '../getProtobufSearchScope';
import { loadProtobuf } from '../lazyExports';

import { ThreadSearchSubmittedProps } from './searchEvents.types';

const packageName = 'events';
const eventName = 'ThreadSearchSubmittedV1';

const getSearchDate = (timestamp?: number) => {
  if (!timestamp) {
    return undefined;
  }

  const date = new Date(timestamp);

  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDay(),
  };
};

type ReportThreadSearchSubmitted = (props: ThreadSearchSubmittedProps) => void;
export const reportThreadSearchSubmitted: ReportThreadSearchSubmitted = async ({
  conversationId,
  logicalId,
  resultType,
  queryLength,
  groupTelemetryId,
  dateFilterStartTimestamp,
  dateFilterEndTimestamp,
}) => {
  const { events } = await loadProtobuf();
  const groupId = groupTelemetryId ? parseInt(groupTelemetryId) : undefined;

  const reportableScope = await getProtobufSearchScope(resultType, groupTelemetryId);
  const startDate = getSearchDate(dateFilterStartTimestamp);
  const endDate = getSearchDate(dateFilterEndTimestamp);

  const threadSearchSubmittedProps = {
    conversationId: conversationId ?? '',
    logicalId: logicalId ?? '',
    length: queryLength,
    groupId,
    scope: reportableScope,
    startDate,
    endDate,
  };

  const threadSearchViewThreadClicked = events.ThreadSearchSubmittedV1.encode(threadSearchSubmittedProps).finish();

  reportUsageV2({
    packageName,
    eventName,
    value: threadSearchViewThreadClicked,
  });
};
